// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckList_container__lNN60","checklist":"CheckList_checklist__2WYev","checkbox":"CheckList_checkbox__159U_"};